export const lxyLangId = {
    dashbordlxy: {
        welcome: 'Selamat datang di sistem ',
        login: 'Gabung',
        logged:   "masuk"

    },
    menuLxy: {
        lawyerFirmList: 'Halaman Firma Hukum'
    },
    lawyerLxy: {
        LawyerLetter: 'Surat somasi',
        LawyerStatus_UNDSend: "Surat belum dikirim", // 未发送
        LawyerStatus_Cancel: "Surat dibatalkan", // 撤回
        change: 'Ubah status',
        sendToOther: "Kirimkan surat somasi ke pihak ketiga",
        Applycounts: "Total pengajuan"
    },
    dataModulelxy: {
        QualityCheck: 'Pengecekan kualitas',
        uncomplete: 'UnComplete',
        anomalyStatistics: "anomaly statistics",
    }
};